import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';

import { BehaviourListModel } from '../../../../../../../core/models/common.models';
import { OrderByPipe } from '../../../../../../../shared/pipes/order-by.pipe';

@Component({
  selector: 'app-define-behavior-wizard-setting-events-step',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzFormModule,
    NzButtonModule,
    NzCheckboxModule,
    OrderByPipe,
  ],
  templateUrl: './define-behavior-wizard-setting-events-step.component.html',
  styleUrl: './define-behavior-wizard-setting-events-step.component.scss',
})
export class DefineBehaviorWizardSettingEventsStepComponent {
  @Input() form!: FormGroup;
  @Input() isRequired = false;
  @Input() behaviourSettingEventList: BehaviourListModel[] = [];
  @Input() onCheckboxChange!: (
    controlName: string,
    checked: boolean,
    value: number
  ) => void;
  @Input() trackById!: (index: number, item: { id: number }) => number;
  @Output() openSettingEvents = new EventEmitter<void>();
}
